<template>
    <div class="dingdingWord">
        <div class="banner"></div>
        <div class="content">
            <ul class="ul-cont">
                <li style="background-color: rgba(214, 228, 246, 0.3);">
                    <p class="p1" style="color: rgb(24, 111, 232);">文档</p>
                    <p class="p2" style="color:#000;">在工作中激发个体创造力</p>
                    <img src="http://img601.yun300.cn/repository/image/74a458a7-4470-4ec1-8a05-df3100a14c7d.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                    <div class="botom">
                        <p class="p3">1、支持插入附件、脑图、流程图、路线图和代码块等 23 种元素</p>
                        <p class="p3">2、@人或划词评论，一键发送钉钉提醒</p>
                        <p class="p3">3、支持生成长图和语音速记</p>
                    </div>
                </li>
                <li style="background-color: rgba(195, 235, 212, 0.3);">
                    <p class="p1" style="color: #159A4d;">表格</p>
                    <p class="p2" style="color:#000;">数据赋能企业降本提效</p>
                    <img src="http://img601.yun300.cn/repository/image/20fcd94f-6c3c-43c9-bad9-bca2c1ab3757.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                    <div class="botom">
                        <p class="p3">1、10w+数据流畅处理，支持本地EXCEL导入</p>
                        <p class="p3">2、独立视图筛选数据，成员之间互不干扰</p>
                        <p class="p3">3、重要数据锁定，指定的人才能访问或编辑</p>
                    </div>
                </li>
                <li style="background-color: rgba(231, 212, 239, 0.3);">
                    <p class="p1" style="color:#A441CC;">脑图</p>
                    <p class="p2" style="color:#000;">解构信息的生产力工具</p>
                    <img src="http://img601.yun300.cn/repository/image/89d04d35-77cd-43e8-a1e6-3cfddadd57ad.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                    <div class="botom">
                        <p class="p3">1、首款可以演示的脑图，让演讲思路清晰、精彩纷呈</p>
                        <p class="p3">2、支持大纲视图，所见即所得，灵感不间断</p>
                        <p class="p3">3、多种思维导图样式风格随心切换</p>
                    </div>
                </li>
                <li style="background-color: rgba(228, 237, 249, 0.3);">
                    <p class="p1" style="color: #0c56cf;">文档</p>
                    <p class="p2" style="color:#000;">在工作中激发个体创造力</p>
                    <img src="http://img601.yun300.cn/repository/image/f37b836d-31cd-4576-956a-37c2adcadcf9.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                    <div class="botom">
                        <p class="p3">1、目录树搭配独有的脑图结构视图，拖拽即整理</p>
                        <p class="p3">2、文档分权限管理，让知识沉淀体系化</p>
                        <p class="p3">3、支持安全水印和禁止复制</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="cont2">
            <div class="box-cont2">
                <div class="box-left">
                    <p class="box-title">多人协同编辑</p>
                    <p>&nbsp;</p>
                    <p class="box-ps">多人多端：</p>
                    <p class="box-ps">讨论、修改不受时空和设备限制</p>
                    <p>&nbsp;</p>
                    <p class="box-ps">云端存储：</p>
                    <p class="box-ps">即写即存，不必担心断电造成的数据丢失：</p>
                    <p>&nbsp;</p>
                    <p class="box-ps">一键分享：</p>
                    <p class="box-ps">不占本地空间，文件以链接形式流转</p>
                </div>
                <div class="box-right">
                    <img src="http://img601.yun300.cn/repository/image/fcb88479-7c85-4b57-b7e4-473d168a80d7.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                </div>
            </div>
        </div>
        <div class="cont3">
            <div class="box-cont3">
                <div class="box-left-cont3">
                    <img src="http://img601.yun300.cn/repository/image/71f37f79-17e0-4026-a030-3ba9c8ce4b6e.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                </div>
                <div class="box-right-cont3">
                    <p class="box-title-cont3">与钉钉场景互通</p>
                    <p>&nbsp;</p>
                    <p class="box-ps-cont3">不是文件孤岛：</p>
                    <p class="box-ps-cont3">钉钉群与文档无缝连通</p>
                    <p>&nbsp;</p>
                    <p class="box-ps-cont3">信息流转闭环：</p>
                    <p class="box-ps-cont3">待办、便签、会议、日程、邮箱高频场景融合</p>
                </div>
            </div>
        </div>
        <div class="cont2">
            <div class="box-cont2">
                <div class="box-left">
                    <p class="box-title">知识管理服务</p>
                    <p>&nbsp;</p>
                    <p class="box-ps">打造有序沉淀的企业智库，驱动企业创新增长</p>
                    <p>&nbsp;</p>
                    <p class="box-ps">工具服务于人，知识同使用者的双向流转</p>
                    <p>&nbsp;</p>
                    <p class="box-ps">盘活企业智力资源的解决方案</p>
                </div>
                <div class="box-right">
                    <img src="http://img601.yun300.cn/repository/image/1de9af4d-a991-45bb-8f9a-f7c32845b407.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                </div>
            </div>
        </div>
        <div class="cont3">
            <div class="box-cont3">
                <div class="box-left-cont3">
                    <img src="http://img601.yun300.cn/repository/image/19249f31-98b1-4435-8a9b-c0d6b2b7ed22.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                </div>
                <div class="box-right-cont3">
                    <p class="box-title-cont3">文件安全可控</p>
                    <p>&nbsp;</p>
                    <p class="box-ps-cont3">事前：细颗粒度权限控制</p>
                    <p>&nbsp;</p>
                    <p class="box-ps-cont3">事中：员工离职一键交接</p>
                    <p>&nbsp;</p>
                    <p class="box-ps-cont3">事后：文档水印和操作留痕</p>
                </div>
            </div>
        </div>
        <div class="cont4">
            <div class="box-cont4">
                <p class="p-cont4-title">全方位场景解决方案</p>
                <ul class="cont4-ul">
                    <li style="background-color: rgba(230, 243, 255, 1);">
                        <p class="p-ul-li-title" style="color:#1a84ee">团队管理</p>
                        <p class="conInfo" style="color:#1a84ee">整合团队资源，通过OKR目标设定、成员协作分工、资源合理分配帮助团队达成目标。挖掘团队潜力，提升团队管理能力。</p>
                    </li>
                    <li style="background-color: rgba(107, 184, 255, 1);">
                        <p class="p-ul-li-title" style="color:#fff">互联网</p>
                        <p class="conInfo" style="color:#fff">帮助互联网产品研发团队打造优秀高效协同管理框架， 需求管理，项目排期，技术文档沉淀，实时高效更新需求状态。</p>
                    </li>
                    <li style="background-color: rgba(230, 243, 255, 1);">
                        <p class="p-ul-li-title" style="color:#1a84ee">电商</p>
                        <p class="conInfo" style="color:#1a84ee">渗透电商团队工作高效文档协同管理，钉钉文档可帮助推进产品设计、采购生产、推广管理、用户管理等业务模块流转。</p>
                    </li>
                    <li style="background-color: rgba(107, 184, 255, 1);">
                        <p class="p-ul-li-title" style="color:#fff">人力与行政</p>
                        <p class="conInfo" style="color:#fff">帮助企业高效推进人力资源数字化、流程化、标准化转型。涵盖人事入职、满岗、换岗、离职整个业务流程。</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>
<style lang='less' scoped>
.dingdingWord{
    width: 100%;
    text-align: left;
    .banner{
        width:100% ;
        height: 450px;
        background-image: url(./banner-pc-img/cpfw_ddwd_1920337.5@1x.png);
        background-size: 100%;
        background-repeat: no-repeat;
    }
    .content{
        width: 80%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        padding: 40px;
        .ul-cont{
            width: 100%;
            height: 480px;
            display: flex;
            justify-content: space-around;
            li{
                width: 23%;
                height: 450px;
                border-radius: 12px;
                padding: 20px;
                display: flex;
                flex-direction: column;
                // justify-content: center;
                align-items: center;
                .p1,.p2{
                    font-size: 26px;
                    line-height: 30px;
                    letter-spacing: 3px;
                }
                .p2{
                    margin-top: 12px;
                    font-size: 22px;
                    letter-spacing: 1.5px;
                }
                img{
                    width: 290px;
                    height: 176px;
                    margin-bottom: 10px;
                    margin-top: 10px;
                }
                .p3{
                    font-size: 16px;
                    color:#000000;
                    line-height: 30px;
                }
            }
        }
    }
    .cont2{
        width: 100%;
        display: flex;
        align-items: center;
        background-color: rgba(247, 248, 250, 1);
        .box-cont2{
            width: 66%;

            margin: 50px auto;
            display: flex;
            align-items: center;
            .box-left{
                width: 50%;
                height: 100%;
                padding-left: 80px;
                padding-top: 60px;
                .box-title{
                    color: #000;
                    font-size: 30px;
                    line-height: 40px;
                }
                .box-ps{
                    font-size: 19px;
                    color:#696969;
                    line-height: 24px;
                }
            }
            .box-right{
                width: 50%;
                height: 100%;
                img{
                    width: 90%;
                    height: 420px;

                }
            }
        }
    }
    .cont3{
        width: 100%;
        display: flex;
        align-items: center;
        .box-cont3{
            width: 66%;
            margin: 50px auto;
            display: flex;
            align-items: center;
            .box-left-cont3{
                width: 50%;
                height: 100%;
                img{
                     width: 90%;
                    height: 420px;

                }

            }
            .box-right-cont3{
                width: 50%;
                height: 100%;
                padding-left: 55px;
                padding-top: 90px;
                .box-title-cont3{
                    color: #000;
                    font-size: 30px;
                    line-height: 40px;
                }
                .box-ps-cont3{
                    font-size: 19px;
                    color:#696969;
                    line-height: 24px;
                }
            }
        }
    }
    .cont4{
        width: 100%;
        display: flex;
        align-items: center;
        background-color: rgba(247, 248, 250, 1);
        .box-cont4{
            width: 80%;
            margin: 40px auto;
            padding: 40px;
            .p-cont4-title{
                font-size: 32px;
                color: #000;
                line-height: 40px;
                margin-bottom: 40px;
                text-align: center;
            }
            .cont4-ul{
                width: 100%;
                display: flex;
                justify-content: space-around;
                li{
                    width: 23%;
                    border-radius: 8px;
                    padding: 0 20px;
                    padding: 40px;
                    .p-ul-li-title{
                        font-size: 25px;
                        text-align:center;
                        margin-bottom: 20px;
                    }
                    .conInfo{
                        font-size: 19px;
                        line-height: 34px;
                    }
                }
            }
        }
    }
}
</style>
